import React from "react";

import { Container, Row } from "reactstrap";

const WarehouseHeader = () => {
  return (
    <>
      <div className="header bg-gradient-warning pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default WarehouseHeader;
